import React, { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { useForm } from "react-hook-form";
import { closeBtn, formBtn1 } from "../Utils/CustomClasses";
import moment from "moment";

export default function ViewMispunchDetailsModal({mispunchModal,setMispunchModal,data}) {
  const {reset,formState: { errors }} = useForm();
  
  const toggle = () => {
    setMispunchModal(false);
    reset();
  };

  return (
    <>
      <Transition appear show={mispunchModal} as={Fragment}>
        <Dialog as="div" className="relative z-[100]" onClose={toggle}>
          <Transition.Child as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0" enterTo="opacity-100" leave="ease-in duration-200" leaveFrom="opacity-100" leaveTo="opacity-0">
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>
          <div className="fixed inset-0 overflow-y-scroll">
            <div className="flex items-center justify-center min-h-full p-4 text-center">
              <Transition.Child as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0 scale-95" enterTo="opacity-100 scale-100" leave="ease-in duration-200" leaveFrom="opacity-100 scale-100" leaveTo="opacity-0 scale-95">
                <Dialog.Panel className="w-full max-w-2xl overflow-hidden text-left align-middle transition-all transform bg-white rounded-lg shadow-xl">
                  <Dialog.Title as="h2" className="w-full px-3 py-4 text-lg font-semibold leading-6 text-white bg-base-color font-tb">Mispunch Details</Dialog.Title>
                  <div className="p-4">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <p className="font-sans-serif font-bold text-[20px] text-black">First Name.</p>
                        <p>{data?.userId?.first_name ? data?.userId?.first_name : "-----"}</p>
                      </div>
                      <div>
                        <p className="font-sans-serif font-bold text-[20px] text-black">Last Name.</p>
                        <p>{data?.userId?.last_name ? data?.userId?.last_name : "-----"}</p>
                      </div>
                      <div>
                        <p className="font-sans-serif font-bold text-[20px] text-black">Email.</p>
                        <p>{data?.userId?.email ? data?.userId?.email : "-----"}</p>
                      </div>
                      <div>
                        <p className="font-sans-serif font-bold text-[20px] text-black">Date</p>
                        <p>{moment(data?.date).format("DD-MM-YYYY") ? moment(data?.date).format("DD-MM-YYYY") : "-----"}</p>
                      </div>
                      <div>
                        <p className="font-sans-serif font-bold text-[20px] text-black">In Time</p>
                        <p>{data?.inTime? data?.inTime:"----"}</p>
                      </div>
                      <div>
                        <p className="font-sans-serif font-bold text-[20px] text-black">Out Time</p>
                        <p>{data?.outTime? data?.outTime:"----"}</p>
                      </div>
                      <div>
                        <p className="font-sans-serif font-bold text-[20px] text-black">Break</p>
                        <p>{data?.break ? "Yes": "No"}</p>
                      </div>
                      <div>
                        <p className="font-sans-serif font-bold text-[20px] text-black">Mispunch</p>
                        <p>{data?.mispunch ? "Yes" : "No"}</p>
                      </div>
                      <div>
                        <p className="font-sans-serif font-bold text-[20px] text-black">Remark</p>
                        <p>{data?.remark ? data?.remark : "-----"}</p>
                      </div>
                      <div>
                        <p className="font-sans-serif font-bold text-[20px] text-black">Comment</p>
                        <p>{data?.comment ? data?.comment : "-----"}</p>
                      </div>
                    </div>
                  </div>
                  <footer className="flex justify-end px-4 py-2 space-x-3 bg-white">
                    <button type="button" className={`${closeBtn}`} onClick={toggle}>Close</button>
                  </footer>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}